import { ExtendedManageSubscriptionsCells } from '../table/ManageSubscriptionsTableBody';
import { ProductEntry, SubscriptionManagementPageDataOut } from '../../../store/api';
import { ExtendedManageSubscriptionTile } from '../table/extended/ExtendedManageSubscriptionTableTile';
import { mapExtendedOverview } from './mapExtendedOverview';
import { mapExtendedIndividual } from './mapExtendedIndividual';
import { mapExtendedShared } from '../../../shared/subscription-management/mappings/mapExtendedShared';

export const mapExtendedBody = (
    subscriptions: SubscriptionManagementPageDataOut,
    onAddCopy: (item: ProductEntry) => void,
    onExpireIssues: (item: ProductEntry) => void
): ExtendedManageSubscriptionsCells => {
    const list: ExtendedManageSubscriptionTile[] = subscriptions.hits.map(item => {
        return {
            product: item.product,
            overview: mapExtendedOverview(item),
            individual: mapExtendedIndividual(item, onAddCopy, onExpireIssues),
            shared: mapExtendedShared(item)
        };
    });

    return {
        type: 'ExtendedManageSubscriptionsCells',
        list
    };
};
